"use client";

import { cn } from "@/components/ui/cn";

export function AudioPlayer({
  src,
  title,
  compact = false,
}: {
  src: string;
  title: string;
  compact?: boolean;
}) {
  return (
    <div className={cn("bg-off-white border-l-4 border-gold p-4", compact ? "" : "p-5")}>
      {!compact ? <div className="text-sm font-bold text-teal mb-2">{title}</div> : null}
      <audio controls src={src} className="w-full" preload="metadata" />
    </div>
  );
}
